module.exports = __webpack_public_path__ + "static/media/claas-isobus.49cc4338.png";